import React, { useEffect, useState } from "react";
import Table from 'UI/Table';
import moment from 'moment'
import Icon from 'UI/FontAwesomeIcon'
import { Query } from "Utilities/incognitaAPI";
import { isEmpty } from "lodash";

const GET_CALLBACK_ISSUES = `
  query GetCallbackIssues($id: Int!) {
    importConfigurationReportCallbackIssues(id: $id) {
      id
      error
      createdAt
      importDurationHumanized
    }
  }
`

const COLUMNS = [
  { Header: 'ID', accessor: 'id', width: 100 },
  { Header: 'Error', accessor: 'error' },
  { Header: 'Duration', accessor: 'importDurationHumanized', width: 150 },
  { Header: 'Created At', accessor: 'createdAt', width: 200, Cell: row => (
    <div className="text-center">
      {row.value ?
        moment.utc(new Date(row.value)).format('YYYY-MM-DD  hh:mm A') :
        <Icon icon="minus" className="text-2xl text-gray-700" />
      }
    </div>
  )}
]

const CallbackIssues = ({ id }) => {
  const [data, setData] = useState([])
  const [errors, setErrors] = useState([])
  const [loading, setLoading] = useState([])

  const fetchData = () => {
    setLoading(true)

    Query(GET_CALLBACK_ISSUES, { id })
    .then((res) => {
      if (res?.errors) {
        setErrors(res.errors.map(e => e.message))
        setData([])
      } else {
        setData(res?.importConfigurationReportCallbackIssues)
        setErrors([])
      }
    })
    .catch(error => setErrors([error]))
    .finally(() => setLoading(false))
  }

  useEffect(fetchData, [])

  const NoDataComponent = () => {
    if (!isEmpty(errors)) return (
      <div className="text-center text-red-600 py-4">
        ERROR: {errors.join(', ')}
      </div>
    )

    return (
      <div className="text-center font-medium text-lg py-3 text-gray-700">
        No Issues
      </div>
    )
  }

  return (
    <Table
      columns={COLUMNS}
      data={data}
      NoDataComponent={NoDataComponent}
      loading={loading}
      showPagination={false}
    />
  )
}

export default CallbackIssues
